import { FormSelectOption } from '../../../components/form/FormSelect';

export class DashboardDialogSelectOption implements FormSelectOption {
  constructor(public value: string, public label: string) {}
}
